<ng-container *ngIf="activeUser$ | async as activeUser">
  <ng-container *ngrxLet="company$ as company">
    <ng-container *ngrxLet="businessPlan$ as businessPlan">
      <div class="company-profile-wrapper relative">
        <section *ngIf="company" class="profile-header">
          <mat-card
            class="h-fit !p-8 !pb-0 !shadow-none !border-b-0 !rounded-b-none"
          >
            <div class="flex flex-row w-full items-baseline">
              <a
                [routerLink]="appRoutes.companies()"
                class="!mr-4"
                mat-icon-button
              >
                <mat-icon>arrow_back</mat-icon>
              </a>

              <section class="w-full relative">
                <div class="mb-4">
                  <div class="!mb-0 inline-flex items-center">
                    <p class="mat-title !text-xl text-darkGray !mb-0 !mr-4">
                      <span>Company Profile of</span>
                      <span class="text-primary-default"
                      >&nbsp;{{ company.name }}</span
                      >
                    </p>
                    <app-status
                      class="block !text-sub"
                      statusMessage="{{
                        companyHelper.renderCompanyStatusLabel(company.status)
                      }}"
                      statusStyle="{{
                        companyHelper.renderCompanyStatusStyle(company.status)
                      }}"
                    ></app-status>
                  </div>

                  <p class="!mb-0 text-lightGray !text-sub">
                    <span>Last modified on&nbsp;</span>
                    <span>{{ company.updatedAt | date: "mediumDate" }}</span>
                  </p>

                  <app-callout
                    *ngIf="
                      company.status === CompanyStatusEnum.InProcess &&
                      activeUser.isCustomer()
                    "
                    appearance="warn"
                    class="block my-2"
                    message="Our team of experts is currently working on your company registration request with utmost care. We'll notify you as soon as it's complete. Stay tuned for more updates!"
                  >
                  </app-callout>
                </div>

                <div class="flex flex-row w-3/5 mb-4">
                  <div class="inline-flex items-center mr-12">
                    <mat-icon class="text-lightGray" matTooltip="website"
                    >language
                    </mat-icon>
                    <span class="text-lightGray text-sub"
                    >&nbsp;{{
                        company.website ? company.website : "N/A"
                      }}</span
                    >
                  </div>

                  <div class="inline-flex items-center">
                    <mat-icon
                      class="text-lightGray"
                      matTooltip="Number of employees"
                    >groups
                    </mat-icon>
                    <span class="text-lightGray text-sub"
                    >&colon;
                      {{
                        company.numberOfEmployees
                          ? company.numberOfEmployees
                          : "N/A"
                      }}</span
                    >
                  </div>
                </div>

                <div
                  *ngIf="!activeUser.isCustomer()"
                  class="flex flex-row justify-end absolute top-0 right-0"
                >
                  <button
                    (click)="onCreateCompanyProfile()"
                    *ngIf="company.status === CompanyStatusEnum.InProcess"
                    color="primary"
                    mat-raised-button
                    class="font-semibold !shadow-none"
                  >
                    Create Company Profile
                  </button>
                  <button
                    (ok)="archiveCompanyHandler()"
                    *ngIf="
                      company.status === CompanyStatusEnum.Active ||
                      (company.status === CompanyStatusEnum.Dormant &&
                        !activeUser.isCustomer())
                    "
                    [confirmMessage]="
                      'Are you sure you want to archive the company profile for ' +
                      company.name +
                      '?\nOnce archived, the customer will no longer be able to perform any requests on this profile.'
                    "
                    [disabled]="submitting$ | async"
                    appConfirmDialog
                    color="primary"
                    mat-raised-button
                    class="flex items-center font-semibold !shadow-none"
                  >
                  <mat-icon class="mr-1 -mt-1">archive</mat-icon> 
                    Archive              
                  </button>
                </div>
              </section>
            </div>
          </mat-card>

          <mat-tab-group
            #tab
            (selectedTabChange)="onTabChange($event)"
            [selectedIndex]="selectedIndex$ | async"
            class="border border-x custom-tab"
          >
            <mat-tab label="Company Info">
              <app-company-info *ngIf="isSelectedTab(CompanyProfileTab.Information)"></app-company-info>
            </mat-tab>

            <mat-tab label="KYC/UBO">
              <app-company-kyc-ubo
                *ngIf="isSelectedTab(CompanyProfileTab.Kyc)"
                [loading]="kycTabLoading$ | async"
              ></app-company-kyc-ubo>
            </mat-tab>

            <mat-tab label="Documentations">
              <app-company-documentations *ngIf="isSelectedTab(CompanyProfileTab.Documents)"></app-company-documentations>
            </mat-tab>

<!--            <mat-tab label="Document Templates" *ngIf="activeUser && activeUser.isCorporateExpert()">-->
<!--              <app-document-template-table [data]="documentTemplateTableData$ | async"></app-document-template-table>-->
<!--            </mat-tab>-->

            <mat-tab *ngIf="businessPlan?.isPremium()" label="Subscriptions">
              <app-company-subscriptions
                *ngIf="isSelectedTab(CompanyProfileTab.Subscriptions)"
                [company]="company"
              ></app-company-subscriptions>
            </mat-tab>
          </mat-tab-group>
        </section>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
